var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"header-wrapper"},[_c('tr',_vm._l((_vm.cols),function(col){return _c('th',{key:col.colId,style:({ width: col.width })},[_vm._v(_vm._s(col.header))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }